export enum ObligatoryFillIn {
  All = -1,
  Excluded = 1,
  Planned = 2,
}

export interface IInReportToggleOption {
  key: ObligatoryFillIn
  label: string
  tooltip: (period?: string) => string
}
